import { Group, TooltipProps, Text } from "@mantine/core"
import { ReactElement } from "react"

import { Label } from "@tfg/ui"

import { HelpHover } from "../HelpHover/HelpHover"

interface LabelWithTooltipProps {
  label: string
  labelClassName?: string
  disabledTooltip?: boolean
  hoverHelperText?: string
  hoverHelperIcon?: ReactElement<SVGElement>
  justify?: "start" | "end" | "space-between" | "space-around" | "center"
  size?: "xs" | "sm" | "md" | "lg"
  toolTipProps?: TooltipProps
  withAsterisk?: boolean
}

export function LabelWithTooltip({
  label,
  hoverHelperText,
  justify = "start",
  size = "xs",
  disabledTooltip = false, // add this to show tooltip even when text isn't overflowing
  withAsterisk = false,
}: LabelWithTooltipProps) {
  return (
    <Group maw="100%" justify={justify} wrap="nowrap">
      <Label
        label={label}
        size={size}
        withAsterisk={withAsterisk}
        disabledTooltip={disabledTooltip}
      />
      {hoverHelperText && (
        <HelpHover>
          <Text maw="100%" size="xs" w="fit-content">
            {hoverHelperText}
          </Text>
        </HelpHover>
      )}
    </Group>
  )
}
